import { render, staticRenderFns } from "./LockedContent.vue?vue&type=template&id=0146fa11"
import script from "./LockedContent.vue?vue&type=script&lang=js"
export * from "./LockedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports